import React, { Component } from 'react';
import classes from './Navigation.module.css';
import NavToggle from './NavToggle/NavToggle';
import cancelWhite from '../../../assets/images/cancel-white.svg';
class Navigation extends Component {
    state = {
        toggleState: false
    }
    componentDidMount() {
        // console.log(this.props.chapters);
        this.player = this.props.player;

    }
    componentDidUpdate() {
        this.checkCurrentChapter();
    }
    toggleNav = () => {
        this.setState({ toggleState: !this.state.toggleState });
    }

    getPreviousSiblings = (elem) => {
        var siblings = [];
        let previous = elem.previousSibling;
        // console.log(previous);
        while (previous) {
            siblings.push(previous);
            previous = previous.previousSibling;
        }
        return siblings;
    }
    removeClassFromSiblings = (elem) => {
        let parent = elem.parentNode;
        for (let children of parent.children) {
            if (children.getAttribute('index') !== elem.getAttribute('index')) {
                children.classList.remove(classes.Watched);
            }
        }
    }
    checkCurrentChapter() {
        // console.log(this.props.currentChapter);
        for (let listItem of document.getElementsByClassName(classes.ListItem)) {
            if (parseInt(listItem.getAttribute('index')) === this.props.currentChapter) {
                this.removeClassFromSiblings(listItem);

                // Löscht die Watched Klasse des aktuellen Elements, sofern eine vorhanden ist. ( Durch Navigieren hervorgerufen)
                if (listItem.className.indexOf(classes.Watched)) {
                    listItem.classList.remove(classes.Watched);
                }
                // Wenn ein Sibling existiert wird von diesem Die Klasse Current entfernt und die Klasse Watched hinzugefügt.
                if (listItem.previousSibling) {
                    for (let previous of this.getPreviousSiblings(listItem)) {
                        if (previous.className.indexOf(classes.Current)) {
                            previous.classList.remove(classes.Current);
                            previous.className += ' ' + classes.Watched;
                        }
                    }
                }
                // if (listItem.previousSibling && listItem.previousSibling.className.indexOf(classes.Current)) {
                //     listItem.previousSibling.classList.remove(classes.Current);
                //     listItem.previousSibling.className += ' ' + classes.Watched;
                // }
                listItem.className += ' ' + classes.Current;
            } else {
                listItem.classList.remove(classes.Current);
            }
        }
    }

    getListItems() {
        let list = [];
        for (let chapter of this.props.chapters) {
            list.push(<li key={chapter.index} index={chapter.index} className={classes.ListItem} onClick={() => { this.props.click(chapter.startTime); this.setState({ toggleState: false }); }}><span>{chapter.title}</span></li>)
        }

        return list;
    }

    render() {
        let toggle = this.state.toggleState && !this.props.modalIsOpen ? classes.Open : ''; // Schließt unteranderem wenn ein Modal offen ist.
        
        if (this.state.toggleState) {
            document.getElementsByTagName('body')[0].style.overflow = "hidden";
        }
        else {
            document.getElementsByTagName('body')[0].style.overflow = "auto";
        }

        const closeStyle = {
            backgroundImage: `url(${cancelWhite})`
        }
        return (
            <>
                <NavToggle click={this.toggleNav} />
                <div className={classes.Navigation + ' ' + toggle}>
                    <h2 className={classes.Headline}>Modulübersicht</h2>
                    <div className={classes.Close} style={closeStyle} onClick={this.toggleNav} />
                    <ul className={classes.ListContainer}>
                        {this.getListItems()}
                        {/* <li className={classes.ListItem + ' ' + classes.Watched}><span>Praxis-Situation - 2</span></li>
                    <li className={classes.ListItem}><span>Praxis-Situation - Auflösung</span></li>
                    <li className={classes.ListItem}><span>Praxis-Situation - 4</span></li>
                    <li className={classes.ListItem}><span>Praxis-Situation - Auflösung</span></li> */}
                    </ul>
                </div>
            </>
        );
    }
}

export default Navigation;